/**
 * Definition for different expense categories
 */
export var ExpenseCategorizationType;
(function (ExpenseCategorizationType) {
  ExpenseCategorizationType[ExpenseCategorizationType["BUDGET_ITEM"] = 0] = "BUDGET_ITEM";
  ExpenseCategorizationType[ExpenseCategorizationType["CATEGORY"] = 1] = "CATEGORY";
  ExpenseCategorizationType[ExpenseCategorizationType["SUB_CATEGORY"] = 2] = "SUB_CATEGORY";
})(ExpenseCategorizationType || (ExpenseCategorizationType = {}));